import {
  RegistroStatus,
  ContaDepositoResponse,
  PagamentoResponse,
  PagamentoExtraordinarioRequest,
  PagamentoSolicitarLiquidacaoRequest,
  PagamentoSolicitarLiquidacaoEmLoteRequest,
  GETConciliacaoAtivoResponse,
  SolicitarLiquidacaoRequest,
  ConciliacaoArquivoResponse,
  GETInstrumentosFilterParams,
  InstrumentoFinanceiroApiResponse,
  PaginatedResult,
  RascunhoFilterResponse,
  RascunhoFilter,
  InstrumentoFinanceiro,
  RascunhoRequest,
  RascunhoDocumentRequest,
  CalcularAmortizacaoRequest,
  CalcularAmortizacaoResponse,
  POSTEventosFinanceirosFilterParams,
  CadastroInstrumentoFinanceiroApiRequest,
  CommandResultTyped,
  FluxoMonitorResult,
  PagamentoDocuments,
  GarantiasResponse,
  InvestidorCertidaoResponse,
  RascunhoIdAndCod,
  TipoLiquidacao,
  OperacaoOfertaPrimariaResponse,
  ReservarUltimoNumeroDaEmissaoRequest,
  AnbimaFundoResponse,
} from 'common/genericTypes';
import { Moment } from 'moment';
import { Dispatch } from 'redux';
import {
  GETContasDeposito,
  POSTContasDepositoPaginated,
  GETConciliacaoDownload,
  GETPagamentos,
  GETPagamento,
  POSTPagamentoExtraordinario,
  POSTAprovarPagamento,
  POSTReprovarPagamento,
  POSTSolicitarLiquidacaoPagamento,
  POSTConfirmarLiquidacaoPagamento,
  POSTCancelarLiquidacaoPagamento,
  POSTCancelarSolicitacaoEvento,
  POSTSolicitarAprovarConfirmarLiquidacaoPagamento,
  POSTSolicitarAprovarConfirmarLiquidacaoEmLote,
  SolicitarAprovarConfirmarLiquidacaoEmLoteRequest,
  GETConciliacoesAtivos,
  POSTEnviarLiquidacao,
  POSTConfirmarConciliacao,
  GETConciliacoesLista,
  POSTValidateInstrumento,
  GETInstrumentos,
  GETInstrumentoDetalhes,
  GETInstrumentoDocumentDownloadUrl,
  POSTSuspenderInstrumento,
  POSTLiberarInstrumento,
  DELETEInstrumento,
  GETInstrumentosPaginated,
  POSTGerarRascunho,
  GETRascunhos,
  GETRascunhosByFilter,
  GETRascunhoByDraftId,
  POSTRascunho,
  PUTRascunho,
  POSTRelatorioCompletoDownload,
  GETCalcularAmortizacao,
  POSTInstrumentosPaginated,
  POSTInstrumentosSaldosAtivosPaginated,
  POSTEventosFinanceirosPaginated,
  POSTEventosFinaceirosCSV,
  POSTGerarFluxoMonitor,
  GETPagamentoDocuments,
  POSTUploadPagamentoDocumento,
  GETGarantiasInstrumento,
  GETInvestidores,
  GETTermoEncerramento,
  GetNumeroEmissoes,
  GETInstrumentosResume,
  GETInstrumentosEventoExtraordinarioResume,
  GETInstrumentosOfertaPrimariaResume,
  POSTUploadCertidaoAtivos,
  POSTContestarLiquidacaoPagamento,
  GETInstrumentoDetalhesByCodigo,
  POSTReservarUltimoNumeroDaEmissao,
  POSTAprovarEdicaoInstrumento,
  POSTRejeitarEdicaoInstrumento,
  POSTLancamentoPU,
  GETConsultarFundoAnbimaPorCnpj,
  POSTImportarMinuta,
  PUTRevisarPUAgenteFiduciario,
  POSTContasDepositoPaginatedFilter,
  POSTSolicitarAprovacaoAF,
  POSTAprovarPUAF,
  POSTReprovarPUAF,
} from 'requests/instrumentos';
import { typedAction } from 'store/modules/base';

export interface InstrumentoApiState {
  getInstrumentoDetalhes(
    dispatch: Dispatch,
    id: string,
    stackRequest?: boolean
  ): Promise<InstrumentoFinanceiroApiResponse>;
  getInstrumentoDetalhesByCodigo(
    dispatch: Dispatch,
    codigoInstrumento: string,
    stackRequest?: boolean
  ): Promise<InstrumentoFinanceiroApiResponse>;
  getInstrumentos( //
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<InstrumentoFinanceiroApiResponse>>;

  getConsultarFundoAnbimaPorCnpj(
    dispatch: Dispatch,
    cnpj: string,
    stackRequest?: boolean
  ): Promise<AnbimaFundoResponse>;

  getInstrumentosResume(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<InstrumentoFinanceiroApiResponse>>;

  getInstrumentosEventoExtraordinarioResume(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<InstrumentoFinanceiroApiResponse>>;

  getInstrumentosOfertaPrimariaResume(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<InstrumentoFinanceiroApiResponse>>;

  getInstrumentosPaginated(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<InstrumentoFinanceiroApiResponse>>;

  postInstrumentosPaginated(
    dispatch: Dispatch,
    filter?: GETInstrumentosFilterParams,
    stackRequest?: boolean,
    emissorId?: string | null,
    custodianteId?:string | null,
    coordenadorId?:string | null,
    agenteFiduciarioId?: string | null,
    escrituradorId?: string | null,
    administradorFiduciarioId?: string | null,
  ): Promise<any>;

  postInstrumentosSaldosAtivosPaginated(
    dispatch: Dispatch,
    filter?: GETInstrumentosFilterParams,
    stackRequest?: boolean,
    emissorId?: string | null,
    custodianteId?: string | null,
    coordenadorId?: string | null,
    agenteFiduciarioId?: string | null,
    escrituradorId?: string | null,
    administradorFiduciarioId?: string | null,
  ): Promise<any>;

  postEventosFinanceirosPaginated(
    dispatch: Dispatch,
    filter?: POSTEventosFinanceirosFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<PagamentoResponse>>;

  postEventosFinanceirosCsv(
    dispatch: Dispatch,
    filter?: POSTEventosFinanceirosFilterParams,
    stackRequest?: boolean
  ): Promise<any>;

  postValidateInstrumento(
    dispatch: Dispatch,
    status: RegistroStatus,
    id: string,
    justificativa?: string,
    attachments?: File[],
    stackRequest?: boolean
  ): Promise<unknown>;

  getInstrumentoDocumentDownloadUrl(dispatch: Dispatch, DocumentId: string, stackRequest?: boolean): Promise<string>;

  postSuspenderInstrumento(
    dispatch: Dispatch,
    instrumentoId: string,
    justificativa: string,
    anexosList: File[],
    stackRequest?: boolean
  ): Promise<InstrumentoFinanceiroApiResponse>;

  postLiberarInstrumento(
    dispatch: Dispatch,
    instrumentoId: string,
    justificativa: string,
    anexosList: File[],
    stackRequest?: boolean
  ): Promise<InstrumentoFinanceiroApiResponse>;

  postEnviarLiquidacao(
    dispatch: Dispatch,
    instrumentoId: string,
    SolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<InstrumentoFinanceiroApiResponse>;

  getContasDeposito(dispatch: Dispatch, stackRequest?: boolean): Promise<Array<ContaDepositoResponse>>;

  postContasDepositoPaginated(
    dispatch: Dispatch,
    filter: POSTContasDepositoPaginatedFilter,
    stackRequest?: boolean
  ): Promise<PaginatedResult<ContaDepositoResponse>>;

  getConciliacaoDownload(dispatch: Dispatch, conciliacaoArquivoId: string, stackRequest?: boolean): Promise<any>;

  postConfirmarConciliacao(dispatch: Dispatch, conciliacaoArquivoId: string, stackRequest?: boolean): Promise<any>;

  getPagamentos(dispatch: Dispatch, stackRequest?: boolean): Promise<Array<PagamentoResponse>>;

  getPagamento(dispatch: Dispatch, pagamentoId: string, stackRequest?: boolean): Promise<PagamentoResponse>;

  getPagamentoDocuments(
    dispatch: Dispatch,
    pagamentoId: string,
    stackRequest?: boolean
  ): Promise<Array<PagamentoDocuments>>;

  postUploadPagamentoDocumento(
    dispatch: Dispatch,
    pagamentoId: string,
    arquivo: File,
    stackRequest?: boolean
  ): Promise<PagamentoDocuments>;

  postPagamentoExtraordinario(
    dispatch: Dispatch,
    instrumentoId: string,
    pagamentoExtraordinarioRequest: PagamentoExtraordinarioRequest,
    stackRequest?: boolean
  ): Promise<PagamentoResponse>;

  postAprovarPagamento(dispatch: Dispatch, pagamentoId: string, tipoLiquidacao: TipoLiquidacao, stackRequest: boolean): Promise<PagamentoResponse>;

  postReprovarPagamento(dispatch: Dispatch, pagamentoId: string, motivoReprovacao?: string, stackRequest?: boolean): Promise<PagamentoResponse>;

  postCancelarSolicitacaoEvento(dispatch: Dispatch, pagamentoId: string, stackRequest?: boolean): Promise<PagamentoResponse>;

  postSolicitarLiquidacaoPagamento(
    dispatch: Dispatch,
    pagamentoId: string,
    pagamentoSolicitarLiquidacaoRequest: PagamentoSolicitarLiquidacaoRequest,
    attachments?: File[],
    stackRequest?: boolean
  ): Promise<unknown>;

  postConfirmarLiquidacaoPagamento(dispatch: Dispatch, pagamentoId: string, stackRequest?: boolean): Promise<unknown>;

  postCancelarLiquidacaoPagamento(dispatch: Dispatch, pagamentoId: string, stackRequest?: boolean): Promise<unknown>;

  postContestarLiquidacaoPagamento(dispatch: Dispatch, pagamentoId: string, stackRequest?: boolean): Promise<unknown>;
  postSolicitarAprovarConfirmarLiquidacaoPagamento(
    dispatch: Dispatch,
    pagamentoId: string,
    pagamentoSolicitarLiquidacaoRequest: PagamentoSolicitarLiquidacaoRequest,
    attachments?: File[],
    stackRequest?: boolean
  ): Promise<unknown>;

  postSolicitarAprovarConfirmarLiquidacaoEmLote(
    dispatch: Dispatch,
    requestBody: SolicitarAprovarConfirmarLiquidacaoEmLoteRequest,
    stackRequest?: boolean
  ): Promise<unknown>;

  getConciliacoesLista(dispatch: Dispatch, stackRequest?: boolean): Promise<ConciliacaoArquivoResponse[]>;

  getConciliacoesAtivos(
    dispatch: Dispatch,
    date: Moment,
    stackRequest?: boolean
  ): Promise<Array<GETConciliacaoAtivoResponse>>;

  deleteInstrumento(
    dispatch: Dispatch,
    instrumentoFinanceiroId: string,
    justificativa: string,
    stackRequest?: boolean
  ): Promise<any>;

  postGerarRascunho(dispatch: Dispatch, instrumentoFinanceiroId: string, stackRequest?: boolean): Promise<string>;

  getRascunhos(dispatch: Dispatch, stackRequest?: boolean): Promise<Array<InstrumentoFinanceiroApiResponse>>;

  getRascunhosByFilter(
    dispatch: Dispatch,
    filter: RascunhoFilter,
    stackRequest?: boolean
  ): Promise<RascunhoFilterResponse>;

  getRascunhoByDraftId<T>(dispatch: Dispatch, draftId: string, stackRequest?: boolean): Promise<T>;

  postRascunho(
    dispatch: Dispatch,
    tipo: InstrumentoFinanceiro,
    rascunho: RascunhoRequest,
    documents?: Array<RascunhoDocumentRequest>,
    stackRequest?: boolean
  ): Promise<RascunhoIdAndCod>;

  putRascunho(
    dispatch: Dispatch,
    tipo: InstrumentoFinanceiro,
    rascunhoId: string,
    rascunho: RascunhoRequest,
    documents?: Array<RascunhoDocumentRequest>,
    stackRequest?: boolean
  ): Promise<RascunhoIdAndCod>;

  postRelatorioCompletoDownload(
    dispatch: Dispatch,
    filter?: GETInstrumentosFilterParams,
    stackRequest?: boolean,
    timeoutMs?: number
  ): Promise<any>;


  getCalcularAmortizacao(
    dispatch: Dispatch,
    calcularAmortizacaoRequest: CalcularAmortizacaoRequest,
    stackRequest?: boolean
  ): Promise<CalcularAmortizacaoResponse>;

  postGerarFluxoMonitor(
    dispatch: Dispatch,
    tipo: string,
    instrumento: CadastroInstrumentoFinanceiroApiRequest,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<Array<FluxoMonitorResult>>>;

  getGarantiasInstrumento(dispatch: Dispatch, stackRequest?: boolean): Promise<GarantiasResponse>;

  getInvestidores(
    dispatch: Dispatch,
    instrumentoFinanceiroId: string,
    stackRequest?: boolean
  ): Promise<Array<InvestidorCertidaoResponse>>;

  getTermoEncerramento(dispatch: Dispatch, instrumentoFinanceiroId: string, stackRequest?: boolean): Promise<string>;

  getNumeroEmissoes(dispatch: Dispatch, emissorCnpj: string, tipoInstrumento: InstrumentoFinanceiro): Promise<string>;

  postReservarUltimoNumeroDaEmissao(dispatch: Dispatch, reservarUltimoNumeroDaEmissaoRequest: ReservarUltimoNumeroDaEmissaoRequest, stackRequest?: boolean): Promise<string>;

  postLancamentoPU(dispatch: Dispatch, instrumentoGuid: string, pu: number, stackRequest?: boolean): Promise<any>;

  postUploadCertidaoAtivos(dispatch: Dispatch, params: string, stackRequest?: boolean): Promise<void>;

  postAprovarEdicaoInstrumento(dispatch: Dispatch, instrumentoFinanceiroId: string, edicaoId: string, stackRequest?: boolean): Promise<InstrumentoFinanceiroApiResponse>;

  postRejeitarEdicaoInstrumento(dispatch: Dispatch, instrumentoFinanceiroId: string, edicaoId: string, stackRequest?: boolean): Promise<InstrumentoFinanceiroApiResponse>;

  postImportarMinuta(dispatch: Dispatch, file: File, stackRequest?: boolean): Promise<any>;

  putRevisarPUAgenteFiduciario(dispatch: Dispatch, request: { pagamentoId: string, puRevisado: number, percentual: number, liquidacaoDireta: boolean }, stackRequest?: boolean): Promise<any>;

  postSolicitarAprovacaoAF(dispatch: Dispatch, pagamentoId: string, payload: { puEmissor?: number; aceitouPUProjetado: boolean }, stackRequest?: boolean): Promise<any>;

  postAprovarPUAF(dispatch: Dispatch, pagamentoId: string, payload: { aceitouPUEmissor: boolean }, stackRequest?: boolean): Promise<any>;

  postReprovarPUAF(dispatch: Dispatch, pagamentoId: string, payload: { puAgenteFiduciario: number }, stackRequest?: boolean): Promise<any>;
}

export const instrumentoApiInicialState: InstrumentoApiState = {
  getInstrumentoDetalhes: GETInstrumentoDetalhes,
  getInstrumentoDetalhesByCodigo: GETInstrumentoDetalhesByCodigo,
  getInstrumentos: GETInstrumentos,
  getInstrumentosResume: GETInstrumentosResume,
  getInstrumentosEventoExtraordinarioResume: GETInstrumentosEventoExtraordinarioResume,
  getInstrumentosOfertaPrimariaResume: GETInstrumentosOfertaPrimariaResume,
  getConsultarFundoAnbimaPorCnpj: GETConsultarFundoAnbimaPorCnpj,
  getInstrumentosPaginated: GETInstrumentosPaginated,
  postValidateInstrumento: POSTValidateInstrumento,
  getInstrumentoDocumentDownloadUrl: GETInstrumentoDocumentDownloadUrl,
  postSuspenderInstrumento: POSTSuspenderInstrumento,
  postLiberarInstrumento: POSTLiberarInstrumento,
  getContasDeposito: GETContasDeposito,
  postContasDepositoPaginated: POSTContasDepositoPaginated,
  getConciliacaoDownload: GETConciliacaoDownload,
  postConfirmarConciliacao: POSTConfirmarConciliacao,
  getPagamentos: GETPagamentos,
  getPagamento: GETPagamento,
  getPagamentoDocuments: GETPagamentoDocuments,
  postUploadPagamentoDocumento: POSTUploadPagamentoDocumento,
  postPagamentoExtraordinario: POSTPagamentoExtraordinario,
  postAprovarPagamento: POSTAprovarPagamento,
  postReprovarPagamento: POSTReprovarPagamento,
  postCancelarSolicitacaoEvento: POSTCancelarSolicitacaoEvento,
  postSolicitarLiquidacaoPagamento: POSTSolicitarLiquidacaoPagamento,
  postSolicitarAprovarConfirmarLiquidacaoPagamento: POSTSolicitarAprovarConfirmarLiquidacaoPagamento,
  postConfirmarLiquidacaoPagamento: POSTConfirmarLiquidacaoPagamento,
  postCancelarLiquidacaoPagamento: POSTCancelarLiquidacaoPagamento,
  postContestarLiquidacaoPagamento: POSTContestarLiquidacaoPagamento,
  postSolicitarAprovarConfirmarLiquidacaoEmLote: POSTSolicitarAprovarConfirmarLiquidacaoEmLote,
  getConciliacoesLista: GETConciliacoesLista,
  getConciliacoesAtivos: GETConciliacoesAtivos,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  deleteInstrumento: DELETEInstrumento,
  postGerarRascunho: POSTGerarRascunho,
  getRascunhos: GETRascunhos,
  getRascunhosByFilter: GETRascunhosByFilter,
  getRascunhoByDraftId: GETRascunhoByDraftId,
  postRascunho: POSTRascunho,
  putRascunho: PUTRascunho,
  postRelatorioCompletoDownload: POSTRelatorioCompletoDownload,
  getCalcularAmortizacao: GETCalcularAmortizacao,
  postInstrumentosPaginated: POSTInstrumentosPaginated,
  postInstrumentosSaldosAtivosPaginated: POSTInstrumentosSaldosAtivosPaginated,
  postEventosFinanceirosPaginated: POSTEventosFinanceirosPaginated,
  postEventosFinanceirosCsv: POSTEventosFinaceirosCSV,
  postGerarFluxoMonitor: POSTGerarFluxoMonitor,
  getGarantiasInstrumento: GETGarantiasInstrumento,
  getInvestidores: GETInvestidores,
  getTermoEncerramento: GETTermoEncerramento,
  getNumeroEmissoes: GetNumeroEmissoes,
  postReservarUltimoNumeroDaEmissao: POSTReservarUltimoNumeroDaEmissao,
  postUploadCertidaoAtivos: POSTUploadCertidaoAtivos,
  postLancamentoPU: POSTLancamentoPU,
  postAprovarEdicaoInstrumento: POSTAprovarEdicaoInstrumento,
  postRejeitarEdicaoInstrumento: POSTRejeitarEdicaoInstrumento,
  postImportarMinuta: POSTImportarMinuta,
  putRevisarPUAgenteFiduciario: PUTRevisarPUAgenteFiduciario,
  postSolicitarAprovacaoAF: POSTSolicitarAprovacaoAF,
  postAprovarPUAF: POSTAprovarPUAF,
  postReprovarPUAF: POSTReprovarPUAF,
};

enum InstrumentoApiActionType {
  Update = 'instrumentoApi/UPDATE',
  Reset = 'instrumentoApi/RESET',
}

export const updateInstrumentoApi = (state: InstrumentoApiState) => {
  return typedAction(InstrumentoApiActionType.Update, state);
};

export const resetInstrumentoApi = () => {
  return typedAction(InstrumentoApiActionType.Reset);
};

type InstrumentoApiAction = ReturnType<typeof updateInstrumentoApi | typeof resetInstrumentoApi>;

export function instrumentoApiReducer( //
  state: InstrumentoApiState = instrumentoApiInicialState,
  action: InstrumentoApiAction
): InstrumentoApiState {
  switch (action.type) {
    case InstrumentoApiActionType.Update:
      return { ...action.payload };
    case InstrumentoApiActionType.Reset:
      return { ...instrumentoApiInicialState };
    default:
      return state;
  }
}
